export let duplicateFavoriteDisplayNameTemplate = "AzGVnd";
export let duplicateFavoriteTooltipTemplate = "gyJ$3d";
export let duplicateFavoriteParentFolderTemplate = "JXNPve";
export let siderailFavoriteTooltipTemplate = "g7BCN";
export let siderailFavoriteTooltipAccountSuffixTemplate = "GxgmCc";
export default {duplicateFavoriteDisplayNameTemplate,duplicateFavoriteTooltipTemplate,duplicateFavoriteParentFolderTemplate,siderailFavoriteTooltipTemplate,siderailFavoriteTooltipAccountSuffixTemplate};